import { RootState } from "../../../../ReduxToolkit/Store";
  
export const selectAssignedManagerDetailsError = (state: RootState) =>
  state.employeeAssignedManagerDetails.error;

export const selectFinancialYearData = (state: RootState) =>
  state.financialYearSlice.attendance.selectedFinancialYear;